export default "__VITE_ASSET__BtfXE6Y2__"